<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M26 15h-9V6a1 1 0 00-2 0v9H6a1 1 0 000 2h9v9a1 1 0 002 0v-9h9a1 1 0 000-2z"/></svg>